import React, { Component } from 'react';
import styled from '@emotion/styled';
import { Colors, PrimaryButton, Modal, device, isMobile } from 'utils';
import ShareProject from './Share/ShareProject';
import PropTypes from 'prop-types';
import ProjectImages from './DetailComponents/ProjectImages';
import { Input } from 'antd';
import { withRouter } from 'react-router-dom';
import ProjectSidebarCard from './DetailComponents/ProjectSideBar';
import ShareButton from './Share/ShareButton';
import LikeButton from './Like/LikeButton';
import DonationReceiptModalButton from './Modals/DonationReceiptModal';
import AvatarBox from './DetailComponents/AvatarBox';
import Finished from './Icons/Finished';
import DOMPurify from 'dompurify';

const { TextArea } = Input;

class ProjectDetails extends Component {
  state = {
    showModal: false,
    showProjectDescriptionModal: false,
    showContactModal: false,
    showFullContent: false,
    projectDescLength: 914,
  };

  static propTypes = {
    projectUrl: PropTypes.string,
    projectDescription: PropTypes.string,
    projectDonations: PropTypes.number,
    projectSupporters: PropTypes.number,
    projectDays: PropTypes.number,
    projectImages: PropTypes.array,
    projectGoal: PropTypes.number,
    projectFinalGoal: PropTypes.number,
    isViewPage: PropTypes.bool.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    banner: PropTypes.string,
    projectId: PropTypes.number,
    projectStatus: PropTypes.string,
    rewardsExist: PropTypes.bool,
    rewardsUpper: PropTypes.bool,
    project: PropTypes.object.isRequired,
    loadingDonations: PropTypes.bool.isRequired,
    getProjectDonations: PropTypes.func.isRequired,
    donations: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showFullContent !== this.state.showFullContent) {
      this.setState({
        projectDescLength: this.state.showFullContent
          ? this.props.projectDescription?.length || 914
          : 914,
      });
    }
  }

  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };

  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };

  handelCloseDescriptionModal = () => {
    this.setState({ showProjectDescriptionModal: false });
    document.body.style.overflowY = 'unset';
  };

  handelShowDescription = () => {
    this.setState((prevState) => ({
      showFullContent: !prevState.showFullContent,
    }));
  };

  getUtmParam = (key) => {
    return (
      new URLSearchParams(this.props.location.search).get(key) ||
      sessionStorage.getItem(key)
    );
  };

  scrollToRewards = () => {
    const targetElement = document.getElementById('rewards-section');

    if (!targetElement) return;

    window.scrollTo({
      top: targetElement.offsetTop - 100,
      behavior: 'smooth',
    });
  };

  render() {
    const {
      showModal,
      showProjectDescriptionModal,
      showContactModal,
      projectDescLength,
      showFullContent,
    } = this.state;

    const {
      projectDescription,
      projectDonations,
      projectSupporters,
      projectDays,
      projectImages = [],
      title,
      projectStatus,
      project,
      loadingDonations,
      getProjectDonations,
      donations,
      projectUrl,
      rewardsUpper,
      rewardsExist,
      isViewPage,
    } = this.props;

    const utmParams = {
      utm_campaign: this.getUtmParam('utm_campaign'),
      utm_source: this.getUtmParam('utm_source'),
      utm_medium: this.getUtmParam('utm_medium'),
      utm_term: this.getUtmParam('utm_term'),
      utm_content: this.getUtmParam('utm_content'),
      utm_adgroup: this.getUtmParam('utm_adgroup'),
      utm_placement: this.getUtmParam('utm_placement'),
      utm_device: this.getUtmParam('utm_device'),
      utm_audience: this.getUtmParam('utm_audience'),
      utm_geo: this.getUtmParam('utm_geo'),
      utm_creative: this.getUtmParam('utm_creative'),
      utm_network: this.getUtmParam('utm_network'),
      utm_id: this.getUtmParam('utm_id'),
    };

    if (projectUrl) {
      localStorage.setItem('project_url', projectUrl);
    }

    Object.entries(utmParams).forEach(([key, value]) => {
      if (value) sessionStorage.setItem(key, value);
    });

    const description = (
      projectDescription && projectDescription.length > projectDescLength
        ? projectDescription.substring(0, projectDescLength) + '...'
        : projectDescription
    )?.replace(/\\r\\n|\\n|\\r/g, '\n');

    const fullDescriptions = projectDescription || '';
    const instaHandle = project?.instagram_url?.split('instagram.com/')[1];
    const donationCount = Number(
      projectSupporters ||
        project?.donations_count ||
        donations?.count ||
        donations?.donations?.length ||
        0
    );
    const hasNoImages = projectImages.length <= 1;
    const hasFewDonations = donationCount < 1;
    const hasManyDonations = donationCount >= 1;
    const hasNoDonation = donationCount === 0;

    const fundingMarginClass =
      hasNoDonation && hasNoImages
        ? ' project-info__funding--no-images-no-donations'
        : hasNoImages && hasFewDonations
        ? ' project-info__funding--no-images-few-donations'
        : hasNoImages && hasManyDonations
        ? ' project-info__funding--no-images-many-donations'
        : '';

    return (
      <div id="project-detail" className="project_detail_bg">
        <TitleSection className="title_subtitile">
          <ProjectTitle
            className="project_detail_heading_lg"
            style={{
              marginTop: project.is_ticketable ? 30 : 0,
              marginBottom: project.is_ticketable ? 35 : undefined,
            }}
          >
            {title}
            {!project.is_ticketable && (
              <LogoRow>
                <AvatarBox
                  project={project}
                  size={40}
                  badgeSize={15}
                  titleSize={14}
                  titleLineHeight={20}
                  subtitleSize={14}
                  subtitleLineHeight={20}
                />
              </LogoRow>
            )}
          </ProjectTitle>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
            }}
            className="project_detail_heading_lg"
          >
            <ShareButton
              project={project}
              viewMode={window?.location?.pathname.startsWith('/view')}
            />
            <LikeButton
              project={project}
              ml={12}
              viewMode={window?.location?.pathname.startsWith('/view')}
            />
          </div>

          <ProjectTitleMobile className="project_detail_heading_mb">
            {title}
            {!project.is_ticketable &&
              (projectStatus === 'successful' ||
                projectStatus === 'finished') && (
                <>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      margin: '16px 0 16px 0',
                    }}
                  >
                    <MobileBadgeFinished>
                      <Finished />
                      <MobileBadgeText>Abgeschlossenes Projekt</MobileBadgeText>
                    </MobileBadgeFinished>
                  </div>
                </>
              )}
            <LogoRowInnerMobile>
              <LogoRowMobile>
                <AvatarBox
                  project={project}
                  size={32}
                  badgeSize={15}
                  titleSize={14}
                  titleLineHeight={18}
                  subtitleSize={14}
                  subtitleLineHeight={18}
                />
              </LogoRowMobile>
            </LogoRowInnerMobile>
          </ProjectTitleMobile>
        </TitleSection>

        <HeroGrid>
          <HeroMediaColumn>
            <ProjectDetailsWrapper>
              <ProjectInfo>
                <div className="project-info__details">
                  {projectImages.length > 0 && (
                    <ProjectImages
                      imageVariants={project.images_variants}
                      projectImages={projectImages}
                      projectMobileImages={project.mobile_array_images}
                    />
                  )}
                </div>
              </ProjectInfo>
            </ProjectDetailsWrapper>
            <MobilePatternAfterImage
              src="/mobile-project-pattern-after-image.svg"
              loading="lazy"
              alt=""
              aria-hidden="true"
            />
          </HeroMediaColumn>

          <HeroAsideColumn>
            <div className="project_footer_wrapper">
              <ProjectFooter>
                <ProjectSidebarCard
                  rewardsUpper={rewardsUpper}
                  rewardsExist={rewardsExist}
                  onShowContactModal={() =>
                    this.setState({ showContactModal: true })
                  }
                  utmParams={utmParams}
                  loadingDonations={loadingDonations}
                  getProjectDonations={getProjectDonations}
                  donations={donations}
                  project={project}
                  projectDays={projectDays}
                  projectSupporters={projectSupporters}
                  projectDonations={projectDonations}
                  instaHandle={instaHandle}
                />
              </ProjectFooter>
            </div>
          </HeroAsideColumn>
        </HeroGrid>

        <div className={`project-info__funding${fundingMarginClass}`}>
          <ProjectDescriptionWrapper>
            {project.is_ticketable && (
              <LogoRowInner>
                <LogoRow>
                  <AvatarBox
                    project={project}
                    size={device.allMobile ? 32 : 56}
                    badgeSize={15}
                    titleSize={device.allMobile ? 14 : 18}
                    titleLineHeight={device.allMobile ? 20 : 28}
                    subtitleSize={device.allMobile ? 12 : 18}
                    subtitleLineHeight={device.allMobile ? 18 : 28}
                  />
                </LogoRow>

                <VerkauferContactButton
                  onClick={() => {
                    window.location.href = `mailto:${project.initiator_email}`;
                  }}
                >
                  {project?.organization_name && project?.organization_type
                    ? 'Veranstalter kontaktieren'
                    : 'Veranstalter kontaktieren'}
                </VerkauferContactButton>
              </LogoRowInner>
            )}
            <img
              src="https://cdn.prod.website-files.com/677e8c6239136af36bc65f94/69613dbf58136fb503ebac61_transparent.svg"
              loading="lazy"
              id="w-node-_0f2674e9-8c87-f117-7ba5-0dcbfeab1f9d-6bc65f9a"
              alt=""
              className="pattern-2"
            />
            <ProjectDescriptionTitle>
              {project.subtitle}
            </ProjectDescriptionTitle>
            <ProjectDescriptionText
              dangerouslySetInnerHTML={{
                __html:
                  DOMPurify.sanitize(description || '', {
                    ALLOWED_TAGS: [
                      'b',
                      'strong',
                      'i',
                      'em',
                      'u',
                      'p',
                      'br',
                      'ul',
                      'ol',
                      'li',
                      'a',
                    ],
                    ALLOWED_ATTR: ['href', 'target', 'rel'],
                  }) ||
                  ''
                    ?.replaceAll('\r\n', '<br/>')
                    ?.replaceAll('\n', '<br/>')
                    ?.replaceAll('\r', '<br/>'),
              }}
            />

            {projectDescription && projectDescription.length > 914 && (
              <LoadMoreWrapper>
                <LoadMoreInner onClick={this.handelShowDescription}>
                  {showFullContent ? 'Weniger anzeigen' : 'Weiterlesen'}
                </LoadMoreInner>
              </LoadMoreWrapper>
            )}
          </ProjectDescriptionWrapper>

          <div className="sepratTargetIconor-lg" />
        </div>

        <DonationReceiptModalButton project={project} />

        {!(projectStatus === 'successful' || projectStatus === 'finished') &&
          project.is_ticketable && (
            <EventShareAndTicket>
              <EventShareButton onClick={this.handelShowModal}>
                {project?.is_ticketable ? 'Event' : 'Projekt'} teilen
              </EventShareButton>

              <EventBookButton
                type="button"
                disabled={isViewPage}
                onClick={isViewPage ? undefined : this.scrollToRewards}
              >
                Ticket buchen
              </EventBookButton>
            </EventShareAndTicket>
          )}

        <Modal showModal={showModal} handelCloseModal={this.handelCloseModal}>
          <ShareProject
            subtitle={project.subtitle}
            title={project.title}
            banner={project.banner}
          />
        </Modal>

        <Modal
          showModal={showProjectDescriptionModal}
          handelCloseModal={this.handelCloseDescriptionModal}
        >
          <DescriptionModal>
            <TextArea
              rows={14}
              readOnly
              className="text_area description-line"
              value={fullDescriptions}
            />

            <div className="button">
              <PrimaryButton onClick={this.handelCloseDescriptionModal}>
                Schließen
              </PrimaryButton>
            </div>
          </DescriptionModal>
        </Modal>

        <Modal
          showModal={showContactModal}
          handelCloseModal={() => this.setState({ showContactModal: false })}
        >
          <ContactModalContent id="test1">
            <ResponsiveH1>Kontaktiere den Veranstalter</ResponsiveH1>

            <ResponsiveText>
              Email: {project?.initiator_email || ''}
            </ResponsiveText>
          </ContactModalContent>
        </Modal>
      </div>
    );
  }
}

export default withRouter(ProjectDetails);

const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(636px, 1fr) minmax(360px, 480px);
  gap: clamp(32px, 7vw, 100px);
  align-items: start;
  justify-content: space-between;
  width: 100%;
  min-width: 0;

  @media (max-width: 1240px) {
    grid-template-columns: minmax(0, 1fr) minmax(340px, 420px);
    gap: 32px;
  }

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  @media ${device.allMobile} {
    gap: 16px;
  }
`;

const HeroMediaColumn = styled.div`
  position: relative;
  z-index: 0;
  min-width: 0;
  width: 100%;
`;

const MobilePatternAfterImage = styled.img`
  display: none;

  @media ${device.allMobile} {
    display: block;
    position: absolute;
    top: 18%;
    left: -20px;
    z-index: -1;
    width: 100vw;
    max-width: none;
    pointer-events: none;
  }
`;

const HeroAsideColumn = styled.aside`
  position: relative;
  z-index: 1;
  min-width: 0;
  width: 100%;

  @media (min-width: 1241px) {
    width: 480px;
  }

  @media (max-width: 1080px) {
    max-width: 680px;
    margin: 0 auto;
  }

  @media ${device.allMobile} {
    max-width: 100%;
  }
`;

const ProjectDetailsWrapper = styled.div`
  position: relative;
  z-index: 1;
  background: transparent;
  border-radius: 12px;
  padding: 0;

  @media ${device.allMobile} {
    width: 100%;
    margin: auto;
    margin-top: 20px;
  }

  @media ${device.tablet} {
    margin-right: 20px;
    margin-left: 20px;
  }
`;

const ProjectInfo = styled.div`
  display: flex;

  @media ${device.allMobile} {
    flex-wrap: wrap;
    width: 100%;
  }

  @media ${device.tablet} {
    flex-wrap: wrap;
    width: 100%;
  }

  & > div {
    padding: 10px;
  }

  .project-info {
    &__description {
      .description-line {
        display: block;
        cursor: default;
      }

      span {
        background: none;
        padding: unset;
        border: none;
        cursor: pointer;

        span {
          color: ${Colors.secondaryColor};

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    &__details {
      min-width: 100%;
      text-align: center;
      padding: 0;

      @media ${device.allMobile} {
        padding: 0;
        width: 100%;
      }

      @media ${device.tablet} {
        width: 100%;
      }
    }

    &__funding {
      min-width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @media ${device.allMobile} {
        width: 100%;
      }

      @media ${device.tablet} {
        width: 100%;
      }

      & > p {
        font-size: 18px;
        line-height: 1.6;
        margin-bottom: 30px;

        @media ${device.allMobile} {
          text-align: center;
        }
      }

      &--actions {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        button {
          margin-bottom: 30px;
          width: 100%;
        }

        @media ${device.allMobile} {
          display: block;

          button {
            margin-bottom: 20px;
            min-width: 100%;
          }
        }

        .donation {
          padding: 0;

          a {
            padding: 15px 20px;
            display: block;

            &:hover {
              color: ${Colors.secondaryColor};
            }
          }
        }
      }
    }
  }

  .project-rewards {
    margin: 30px 0;
    font-size: 26px;
    font-weight: 780;

    @media ${device.laptop} {
      font-size: 18px;
    }

    @media ${device.tablet} {
      font-size: 20px;
      text-align: start !important;
    }

    @media ${device.allMobile} {
      font-size: 16px;
      text-align: start !important;
    }
  }

  .project-rewards-gift {
    font-size: 60px;

    @media ${device.laptop} {
      font-size: 40px;
    }

    @media ${device.tablet} {
      font-size: 40px;
    }

    @media ${device.allMobile} {
      font-size: 24px;
    }
  }

  .project-rewards-gift:hover,
  .project-rewards-inner:hover {
    color: #95bd51;
    cursor: pointer;
  }
`;

const ProjectFooter = styled.div`
  @media ${device.allMobile} {
    padding: 5px 0px;
    text-align: center;
  }

  .project-info {
    &__numbers {
      display: flex;
      flex-direction: column;
      margin-top: 10px;

      @media ${device.allMobile} {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
      }

      img {
        width: 55px;
        height: 55px;
        margin-right: 20px;
      }

      & > div {
        display: flex;
        align-items: center;

        @media ${device.allMobile} {
          margin-bottom: 5px;
          width: 100%;
          justify-content: flex-start;
        }

        & > span {
          margin: 0;
          margin-right: 20px;
        }

        p {
          margin: 0;
          line-height: 1;
          font-weight: 300;
          opacity: 0.7;
          margin-top: 5px;

          &:first-of-type {
            font-size: 18px;
            margin-top: 10px;
            font-weight: bold;
            opacity: 1;

            @media ${device.allMobile} {
              font-size: 14px;
              margin-top: 10px;
            }
          }
        }
      }
    }

    .progress-bar {
      div {
        height: 10px;
        border-radius: 5px 0 10px 5px;
      }

      &.complete {
        div {
          border-radius: 5px;
        }
      }
    }
  }
`;

const DescriptionModal = styled.div`
  @media ${device.allMobile} {
    text-align: center;
  }

  .description-line {
    display: block;
  }

  .button {
    text-align: center;
  }
`;

const ResponsiveH1 = styled.h1`
  color: #95bd51;

  @media (max-width: 576px) {
    font-size: 15px;
    text-align: center;
  }
`;

const ResponsiveText = styled.p`
  @media (max-width: 768px) {
    font-size: 15px;
    text-align: center;
  }
`;

const ContactModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;

const ProjectDescriptionWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: visible;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .pattern-2 {
    position: absolute;
    z-index: -2;

    top: -100px;

    left: 50%;
    transform: translateX(-50%);

    width: 100vw;
    min-width: 100vw;
    max-width: unset;
    

    background-image: url('https://cdn.prod.website-files.com/677e8c6239136af36bc65f94/6782d8d457f9a3ad39bf04ae_pattern%202.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;

    pointer-events: none;

    @media ${device.allMobile} {
      display: none;
    }
  }
`;

const ProjectDescriptionText = styled.p`
  max-width: 764px;
  width: 100%;
  color: #535862 !important;
  font-size: 18px !important;
  font-weight: 400 !important;
  font-family: 'Inter';
  overflow-wrap: anywhere;

  word-break: break-word;

  white-space: pre-wrap;

  @media ${device.allMobile} {
    /* Text sm/Regular */
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    /* or 143% */

    color: #535862 !important;
  }

  p {
    color: #535862 !important;

    font-size: 18px !important;
    font-weight: 400 !important;
    font-family: 'Inter';
    margin-bottom: 0;
    @media ${device.allMobile} {
      /* Text sm/Regular */
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400 !important;
      font-size: 14px !important;
      line-height: 20px !important;
      /* or 143% */

      margin-bottom: 0;
      color: #535862 !important;
    }
  }
`;

const LoadMoreWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
max-width: 764px;
`;

const LoadMoreInner = styled.div`
  cursor: pointer;
  /* Text lg/Regular */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  text-decoration-line: underline;

  color: #9dbc60;

  text-align: left;
  @media ${device.allMobile} {
    /* Paragraph */
    /* Text sm/Regular */
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */
    text-decoration-line: underline;
    text-align: left;

    color: #9dbc60;
  }
`;

const ProjectTitle = styled.h1`
  min-width: 0;
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #181d27;
`;

const TitleSection = styled.div`
  @media ${device.allMobile} {
    position: relative;
    z-index: 3;
    isolation: isolate;
    overflow: visible;
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: -5px;
    padding: 20px 20px 0px 20px;

    &::before {
      content: '';
      position: absolute;
      inset: -120px -20px -180px;
      z-index: -1;
      background-image: url('/Pattern.png');
      background-position: left -12vw top -8vw;
      background-repeat: no-repeat;
      background-size: 155vw auto;
      opacity: 1;
      transform: rotate(4deg);
      transform-origin: center;
      clip-path: inset(0 0 180px 0);
      pointer-events: none;
    }
  }
`;

const ProjectTitleMobile = styled.h1`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin: 0px 32px 0px 16px;
  width: 100%;
  color: #181d27;
`;

const ProjectDescriptionTitle = styled.h2`
  justify-content: center;
  align-items: center;
  max-width: 764px;
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #535862;

  @media ${device.allMobile} {
    /* Text lg/Semibold */
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    /* or 156% */

    color: #535862;
  }
`;

const LogoRowInnerMobile = styled.div`
  justify-content: center;
  align-content: center;
  align-items: center;
  
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  margin-top: 4px;
  font-size: 20px;
  line-height: 18px;
  color: #535862;
  display: flex;
  margin-bottom: 0px;

  @media ${device.allMobile} {
    flex-direction: column;
  }
`;

const LogoRowInner = styled.div`
  justify-content: space-between;
  align-items: center;
  max-width: 764px;
  margin-bottom: 32px;
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #535862;
  display: flex;

  @media ${device.allMobile} {
    flex-direction: column;
  }
`;

const LogoRowMobile = styled.div`
  display: flex;
  margin-top: 12px;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: auto;
`;

const LogoRow = styled.div`
  display: flex;
  margin-top: 12px;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const EventShareAndTicket = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  margin: 64px auto;
  width: 100%;
  max-width: 768px;
  height: 60px;

  @media ${device.allMobile} {
    display: none;
  }
`;

const EventShareButton = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 22px;
  gap: 8px;
  flex: 1;
  min-width: 0;
  max-width: 352px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #d5d7da;
  box-shadow:
    0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  border-radius: 10px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
`;

const EventBookButton = styled.button`
  cursor: pointer;
  border: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 22px;
  gap: 8px;
  flex: 1;
  min-width: 0;
  max-width: 352px;
  height: 60px;
  color: #ffffff;
  background: #9dbc60;
  box-shadow:
    0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  border-radius: 10px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

const VerkauferContactButton = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 20px;
  gap: 6px;
  margin: 0 auto;
  min-width: 238px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #d5d7da;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #414651;

  @media ${device.allMobile} {
    /* Buttons/Button */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 12px;
    gap: 4px;
    

    background: #ffffff;
    border: 1px solid #d5d7da;
    /* Shadows/shadow-xs-skeuomorphic
    
    Used to create a subtle skeuomorphic effect in components such as buttons and tabs.
    
    This can be removed or replaced with shadow-xs if you prefer a flat style.
    */
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
      inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
      inset 0px -2px 0px rgba(10, 13, 18, 0.05);
    border-radius: 8px;


    
    margin-top: 16px;
    width: 100%;
  }
`;

const MobileBadgeFinished = styled.div`
  /* Badge group */
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 13px 10px;
  gap: 6px;

  align-content: center;
  width: 213px;
  height: 28px;

  background: #f5fbee;
  border: 1px solid #ceeab0;
  border-radius: 9999px;
`;

const MobileBadgeText = styled.div`
  /* Message */
  
/* Text sm/Medium */
font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
/* identical to box height, or 143% */

color: #3F621A;


  `
